import clsx from 'clsx';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  options: Array<SegmentedOption<T>>;
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
}

export function SegmentedControl<T extends string>({ options, value, onChange, ariaLabel }: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className="grid gap-2"
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
    >

      {options.map((opt) => {
        const selected = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={clsx(
              'min-h-12 rounded-lg font-heading font-semibold text-sm border-2 transition-colors px-1',
              // teal-dark (not teal) so this 14px/600 label clears WCAG AA
              // on its own - plain --teal only passes at >=18.67px bold,
              // see the QA report, P3 #15 / reverify partial.
              selected ? 'bg-teal-dark text-white border-teal-dark' : 'bg-surface text-teal-dark border-border',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
